import React from 'react';
import { SearchByPropertyResultItem } from 'pages/Search/models';
import LiensList from '../LiensList/LiensList';
import DocumentsList from '../DocumentsList/DocumentsList';
import Assesments from '../Assesment/Assesments';
import { Tabs, Badge } from 'antd';
import { ResultTypeName } from 'pages/Search/Search.types';

const { TabPane } = Tabs;

const SearchByPropertyResultTabs: React.FC<{
  result: SearchByPropertyResultItem | null;
  searchId: number;
}> = (props: {
  result: SearchByPropertyResultItem | null;
  searchId: number;
}) => {
  const { result, searchId } = props;
  const resultType: ResultTypeName = 'propertyResult';

  return (
    <Tabs type="card">
      {result && result.assessment && (
        <TabPane
          tab={
            <>
              Assessment Data&nbsp;
              <Badge
                showZero={true}
                count={result.assessment.hasValues ? 1 : 0}
              />
            </>
          }
          key="assesments"
        >
          <Assesments
            assessment={result.assessment}
            searchCriteria={result.searchCriteria}
            resultItemIndex={result.index}
          />
        </TabPane>
      )}
      {result && result.recordedDocuments && (
        <TabPane
          tab={
            <>
              Recorded Documents&nbsp;
              <Badge
                showZero={true}
                count={result.recordedDocuments.items.length}
              />
            </>
          }
          key="recordedDocuments"
        >
          <DocumentsList
            documents={result.recordedDocuments}
            groupName={result.searchCriteria}
            compName="recordedDocuments"
            resultType={resultType}
            resultItemIndex={result.index}
          />
        </TabPane>
      )}
      {result && result.liens && (
        <TabPane
          tab={
            <>
              Filed Liens&nbsp;
              <Badge showZero={true} count={result.liens.items.length} />
            </>
          }
          key="liens"
        >
          <LiensList
            searchId={searchId}
            liens={result.liens}
            groupName={result.searchCriteria}
            compName={'liens'}
            resultType={resultType}
            resultItemIndex={result.index}
          />
        </TabPane>
      )}
    </Tabs>
  );
};

export default React.memo(SearchByPropertyResultTabs);
